import { dom, library } from "@fortawesome/fontawesome-svg-core";
// 1. Import icons here
import {

    faAngleDown,
    faBars,
} from "@fortawesome/pro-light-svg-icons";

import {
    faSearch,
    faTimes,
    faArrowRight,
    faArrowLeft,
    faPlus,
    faMinus,
    faChevronDown,
    faChevronUp,
} from "@fortawesome/pro-regular-svg-icons";

import {
    faPhone,
    faEnvelope,
    faMapMarker,
    faMegaphone,
    faExclamationCircle,
    faNewspaper,
    faTimes as faTimesSolid,
} from "@fortawesome/pro-solid-svg-icons";

export default function() {
    // 2. make imported icons available
    library.add(
        // light
        faAngleDown,
        // regular
        faSearch,
        faTimes,
        faArrowRight,
        faArrowLeft,
        faPlus,
        faMinus,
        faChevronDown,
        faChevronUp,
        // solid
        faPhone,
        faEnvelope,
        faMapMarker,
        faMegaphone,
        faExclamationCircle,
        faNewspaper,
        faBars,
        faTimesSolid
    );
    
    dom.watch();
}